import React, { Fragment } from "react";
import styles from "./Logo.module.scss";

const Logo = () => {
  return (
    <Fragment >
      <img className={styles.Logo}
        src="https://flowminder.github.io/school-optimisation-resources-nigeria/header.png"
        alt="GRID3 Logo"
      />
    </Fragment>
  );
};

export default Logo;
